export default __webpack_public_path__ + "static/media/info-16px.3f6b77a3.svg";